import React, {useState,useRef, useEffect} from "react";
import "./help.css";
const Help = () =>{

    const [isOpen, setIsOpen] = useState(true); // Set default state to true (popup open)
    const modalRef = useRef(null); // Reference for the modal
    const closeButtonRef = useRef(null); // Reference for the close button

    // Function to close the modal
const handleClose = () => {
  setIsOpen(false); // Set state to false to close the modal
};


  // Function to handle clicks outside the modal
  const handleOutsideClick = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target) && !closeButtonRef.current.contains(event.target)) {
      handleClose(); // Close the modal if the click is outside
    }
  };

  useEffect(() => {
    // Add the event listener on component mount
    document.addEventListener("mousedown", handleOutsideClick);

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, []);


     return(
        <>
         {isOpen && (
         
        <div className="help" ref={modalRef}>
            <div className="close-button-help" ref={closeButtonRef}>
                        <button className="close-popup-btn-help" onClick={handleClose} >
                        ✖
                        </button>
            </div>
            <div className="heading-help">
                <h1>HELP</h1>
            </div>
            <div className="help-content">
            <div className="about-help">
                <p>Welcome to the Pixwala Help Center! Whether you're looking for more information about our services, need assistance with a specific issue, or have questions regarding your experience on our website, we're here to help.</p>
             </div>

             <div className="bulletPoints-help">
                    <div className="heading-bulletPoints-help">
                    General Information
                    </div>
                    <div className="data-bulletPoints-help" >
                        <p><strong>What services do you offer?</strong></p>
                        <p>We provide a wide range of digital services, including:</p>
                        <ol className=" custom-list-help custome-list-1-help">
                            <li><span><strong>Graphic Designing:</strong> Custom graphics for businesses, events, and more.</span></li>
                            <li><span><strong>Video Editing:</strong> Professional video editing for various platforms.</span></li>
                            <li><span><strong>Social Media Management:</strong> Comprehensive management and strategy for social media.</span></li>
                            <li><span><strong>Website Development:</strong> Full-stack website design and development.</span></li>
                            <li><span><strong>App Development: </strong> Custom mobile app development.</span></li>
                            <li><span><strong>Event Shoots: </strong> Professional photography and video coverage of events.</span></li>
                        </ol>
                       
                        <p>You can view more details about each service on our Services page.</p>
                    </div>

                    <div className="heading-bulletPoints-help">
                    How We Use Your Data                
                    </div>
                    <div className="data-bulletPoints-help" >
                    <p><strong>How do I request a quote or service?</strong></p>
                    <p>To request a service or get a quote, please visit our Contact Us page and fill out the form with the details of your requirements. Alternatively, you can reach out to us directly via email or WhatsApp, and our team will get in touch with you.</p>
                    {/* <ol className="custom-list custome-list-2"> */}
                    </div>

                    <div className="heading-bulletPoints-help">
                    Portfolio and Work Samples             
                    </div>
                    <div className="data-bulletPoints-help" >
                    <p><strong>Can I view your portfolio?</strong></p>
                    <p>Yes! We showcase our portfolio to potential clients. If you're interested, simply reach out to us through the Contact Us page, and we will send you our portfolio via email or WhatsApp. Please note that all images in our portfolio are watermarked with our logo for branding purposes.</p>
                    {/* <ol className="custom-list custome-list-3"> */}
                    </div>

                    <div className="heading-bulletPoints-help">
                    Privacy and Data Protection               
                    </div>
                    <div className="data-bulletPoints-help" >
                    <p><strong>How is my personal information used?</strong></p>
                    <p>We take your privacy seriously. We only collect the necessary details (name, email, phone number, and country) to provide our services and support. We do not share your information with third parties. For more information, please review our Privacy Policy.</p>
                    {/* <ol className="custom-list custome-list-4"> */}
                    </div>

                    <div className="heading-bulletPoints-help">
                    Payments and Billing            
                    </div>
                    <div className="data-bulletPoints-help" >
                    <p><strong>How do I pay for the services?</strong></p>
                    <p>Payments for our services are processed securely. Once we agree on the scope of work, we will provide you with an invoice. We accept multiple payment methods and will guide you through the process.</p>
                    {/* <ol className="custom-list custome-list-5"> */}
                    </div>

                    <div className="heading-bulletPoints-help">
                    Copyright and Content Usage            
                    </div>
                    <div className="data-bulletPoints-help" >
                    <p><strong>Can I use the images and videos on your website?</strong></p>
                    <p>All content on our website, including images, videos, and portfolio work, is created by us and protected by copyright. You may not use, download, or distribute our content without permission. If you wish to share our portfolio, we provide it to clients via email or WhatsApp with watermarks.</p>
                    {/* <ol className="custom-list custome-list-6"> */}
                    </div>

                    <div className="heading-bulletPoints-help">
                    Customer Support         
                    </div>
                    <div className="data-bulletPoints-help" >
                    <p><strong>How can I contact customer support?</strong></p>
                    <p>If you need help with a service or have any questions, please feel free to reach out to our support team via:</p>
                    <ol className=" custom-list-help custome-list-7-help">
                        <li><span><strong>Email: </strong>contact@pixwala.com</span></li>
                        <li><span><strong>Phone: </strong>+91 86996-21455</span></li>
                        <li><span><strong>WhatsApp: </strong>+91 86996-21455</span></li>
                    </ol>
                    </div>

                    <div className="heading-bulletPoints-help">
                    Terms and Conditions          
                    </div>
                    <div className="data-bulletPoints-help" >
                    <p><strong>Where can I find your Terms and Conditions?</strong></p>
                    <p>You can view our full Terms and Conditions at any time by visiting the footer section of our website.</p>
                    {/* <ol className="custom-list custome-list-8"> */}
                    </div>

                    <div className="heading-bulletPoints-help">
                    Frequently Asked Questions           
                    </div>
                    <div className="data-bulletPoints-help" >
                    <p><strong>Do you offer discounts or promotions?</strong></p>
                    <p>We occasionally offer discounts or promotions. Stay updated by following us on social media or subscribing to our newsletter for the latest offers.</p>
                    {/* <ol className="custom-list custome-list-9"> */}
                    </div>

                </div>

            </div>           
           
        </div>
        )}
        </>
    );
};
export default Help;